import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { LsMultiSelectModule } from '../select/multi/ls-multi-select/ls-multi-select.module';
import { SwitchTableComponent } from './switch-table.component';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
  imports: [CommonModule, LsMultiSelectModule, FormsModule, TooltipModule],
  declarations: [SwitchTableComponent],
  exports: [SwitchTableComponent]
})
export class SwitchTableModule {}
